import joi from 'joi';
import { DomainSetupSteps } from '../gamification-api-client';
import { MAX_DOMAIN_LENGTH } from '../../constants';

export interface DomainAttributes {
  id: string;
  accountId: string;
  programId: string;
  domain: string;
  textField: string;
  setup: DomainSetup;
  createdAt?: string;
  deletedAt?: string;
  updatedAt?: string;
  isNew?: boolean;
  isActive: boolean;
  developmentMode?: boolean;
}

export interface DomainSetup {
  [DomainSetupSteps.DATABASE]: boolean;
  [DomainSetupSteps.TEXTFIELD_VERIFICATION]: boolean | undefined;
  [DomainSetupSteps.CNAME_VERIFICATION]: boolean | undefined;
  [DomainSetupSteps.SSL_CERTIFICATE]: boolean;
  [DomainSetupSteps.WHITELIST_REDIRECT_URI]: boolean;
  [DomainSetupSteps.UPDATE_ROUTING]: { redirectId: number } | false;
  [DomainSetupSteps.PARTIALLY_DELETED]?: boolean;
}

export interface AddDomainInput {
  programId: string;
  domain: string;
  developmentMode?: boolean;
}

export interface GetDomainsInput {
  accountId: string;
  programId?: string;
  id?: string;
}

export const customerDomainSchema = joi.string().hostname().max(MAX_DOMAIN_LENGTH);

export function isSecondLevelDomain(domainUrl: string): boolean {
  return !domainUrl || /.+\..+\..+/.test(domainUrl);
}
